(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/reminder/assets/javascripts/animations.js') >= 0) return;  svs.modules.push('/components/tur/reminder/assets/javascripts/animations.js');
"use strict";



const animations = (element, bubble) => ({
  containerUp: () => gsap.fromTo(element, {
    y: 140,
    opacity: 1
  }, {
    duration: 0.9,
    ease: 'elastic.out(1,0.3)',
    y: 70,
    opacity: 1
  }),
  containerDown: () => gsap.to(element, {
    duration: 0.2,
    y: 100,
    delay: 0
  }),
  arrowUp: () => gsap.fromTo(bubble, {
    opacity: 0,
    y: 0,
    scale: 0.5
  }, {
    duration: 0.9,
    visibility: 'visible',
    opacity: 1,
    scale: 1,
    y: -68,
    ease: 'elastic.out(1,0.3)'
  }),
  arrowWiggle: () => {
    const tl = gsap.timeline();
    tl.to(bubble, {
      duration: 1.5,
      ease: 'linear',
      y: -62
    });
    tl.to(bubble, {
      duration: 1.5,
      ease: 'linear',
      y: -68
    });
    return tl;
  },
  arrowMinimize: () => gsap.to(bubble, {
    y: svs.core.detect.formfactor.mobile() ? -93 : -65,
    scale: 0.6,
    duration: 0.2
  }),
  arrowDown: () => gsap.to(bubble, {
    y: -40,
    duration: 0.3,
    scale: 0.2
  })
});
setGlobal('svs.tur.reminder.animations', animations);

 })(window);